import { v4 as uuid } from 'uuid';

/**
 * Generates a unique action id
 * keywords: generate id, actionId
 */
const generateActionId = (): string => 'fbpa' + uuid();

export default generateActionId;
